import React from 'react';
import '../styles/Loader.css';

export default function Loader() {
  return <div className="loader">Running model…</div>;
}
